export class CookiesUtils {
	public static getCookieValue(name: string) {
		const cookie = document.cookie.match(new RegExp(name + '=([^;]+)'));
		return !!cookie ? cookie[1] : null;
	}

	public static deleteCookie(name) {
		this.setCookieValue(name, '', -1);
	}


	public static setCookieValue(name: string, value: string, expireDays: number, path: string = '') {
		const expireDate = new Date();
		expireDate.setTime(expireDate.getTime() + expireDays * 24 * 60 * 60 * 1000);
		const expires = `expires=${expireDate.toUTCString()}`;
		const cookiePath = path ? `; path=${path}` : '';
		document.cookie = `${name}=${value}; ${expires}${cookiePath}`;
	}
}
